<div class="h-screen h-[100dvh] flex flex-col" (click)="enableAudioOnce()">
  <app-call />
  <app-network-disconnect-notice />
  <div class="flex-1 min-h-0">
    <router-outlet></router-outlet>
  </div>
</div>

<app-modal-permission />
@if (!soundEnabled()) {
  <button (click)="enableCallAudio()" class="hidden">123</button>
}
